import { render, staticRenderFns } from "./TrsaccRsultInqDtl1.vue?vue&type=template&id=21d275f6"
import script from "./TrsaccRsultInqDtl1.vue?vue&type=script&lang=js"
export * from "./TrsaccRsultInqDtl1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d275f6')) {
      api.createRecord('21d275f6', component.options)
    } else {
      api.reload('21d275f6', component.options)
    }
    module.hot.accept("./TrsaccRsultInqDtl1.vue?vue&type=template&id=21d275f6", function () {
      api.rerender('21d275f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/transfer/TrsaccRsultInqDtl1.vue"
export default component.exports